import { useState, useEffect } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { UseDiscountManagment } from "../UseDiscountManagment";
import SearchComOff from "../../../ContentManagement/firstPage/HomeOffer/SearchComOff";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import BrandSearchCom from "../../../basic-information/brand/BrandSearchCom";
import SelectGroup from "../../../ContentManagement/firstPage/HomeOffer/SelectGroup";
import { useSnackbar } from "notistack";
import DeleteRow from "../../../components/DeleteRow";
import { toMoney, removeComma } from "../../../util/Utils";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddDirectDisccount(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { addDirectDiscount, deleteDirectDiscount } = UseDiscountManagment();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [discountPercent1, setDiscountPercent1] = useState("");
  const [discountPercent2, setDiscountPercent2] = useState("");
  const [discountPercent3, setDiscountPercent3] = useState("");
  const [name, setName] = useState("");
  const [state, setState] = useState({
    productID: undefined,
    brandID: undefined,
    groupID: undefined,
    discountPercent: undefined,
    discountCost: 0,
  });
  const { isSmall } = useBreakpoints();

  return (
    <Box>
      <Typography color="secondary" sx={{ mb: 2 }} variant="subtitle1">
        افزودن تخفیف
      </Typography>
      <Box
        sx={{
          mb: 4,
          borderRadius: 1,
          p: 2,
          boxShadow: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 10"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
              alignItems: isSmall ? "flex-start" : "center",
              gap: 2,
            }}
          >
            <SearchComOff
              article={isSmall ? true : false}
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <TextField
                sx={{
                  width: "50%",
                  input: {
                    textAlign: "center",
                  },
                }}
                value={discountPercent1 ? discountPercent1 : ""}
                label="درصد تخفیف"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setDiscountPercent1(evt.target.value);
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                sx={{
                  width: "50%",
                  input: {
                    textAlign: "center",
                  },
                }}
                value={state.discountCost ? toMoney(state.discountCost) : ""}
                label="قیمت تخفیف(تومان)"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({
                    ...state,
                    discountCost: removeComma(evt.target.value),
                  });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                // width: "100%",
                gap: 2,
              }}
            >
              <Button
                sx={{ width: "70px" }}
                variant="contained"
                onClick={() => {
                  var model = {
                    productID: state.productID,
                    discountPercent: discountPercent1,
                  };
                  var model2 = {
                    productID: state.productID,
                    discountCost: state.discountCost ? state.discountCost : 0,
                  };
                  if (model.productID && model.discountPercent) {
                    addDirectDiscount(model, (calback) => {
                      setState({
                        productID: undefined,
                        brandID: undefined,
                        groupID: undefined,
                        discountPercent: undefined,
                        discountCost: 0,
                      });
                      setDiscountPercent1("");
                      props.callback();
                    });
                  } else if (model2.productID && model2.discountCost) {
                    addDirectDiscount(model2, (calback) => {
                      setState({
                        productID: undefined,
                        brandID: undefined,
                        groupID: undefined,
                        discountPercent: undefined,
                        discountCost: 0,
                      });
                      setDiscountPercent1("");
                      props.callback();
                    });
                  } else {
                    enqueueSnackbar("اطلاعات تخفیف مشخص نیست", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  }
                  // addDirectDiscount(model, (calback) => {
                  //   setState({
                  //     productID: undefined,
                  //     brandID: undefined,
                  //     groupID: undefined,
                  //     discountPercent: undefined,
                  //     discountCost: undefined,
                  //   });
                  //   setDiscountPercent1("");
                  //   props.callback();
                  // });
                }}
              >
                افزودن
              </Button>
              <Button
                sx={{ width: "70px" }}
                variant="contained"
                color="error"
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: "تخفیف این محصول",
                    productID: state.productID,
                  });
                }}
              >
                حذف
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mb: 4,
          borderRadius: 1,
          p: 2,
          boxShadow: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn={isSmall ? "span 12" : "span 4"}>
          <BrandSearchCom
            name={name}
            setName={setName}
            selectedBrandID={state.brandID}
            setter={setState}
            lvl1State={state}
            Offer
          ></BrandSearchCom>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            gap: 2,
          }}
          gridColumn={isSmall ? "span 12" : "span 7"}
        >
          <TextField
            sx={{
              width: isSmall ? "50%" : "25%",
              mr: 2,
              input: {
                textAlign: "center",
              },
            }}
            value={discountPercent2 ? discountPercent2 : ""}
            label="درصد تخفیف"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setDiscountPercent2(evt.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isSmall && "flex-end",
              // width: "100%",
              gap: 2,
            }}
          >
            <Button
              sx={{ width: "70px" }}
              variant="contained"
              onClick={() => {
                var model = {
                  brandID: state.brandID,
                  discountPercent: discountPercent2,
                };
                if (!model.brandID || !model.discountPercent) {
                  enqueueSnackbar("اطلاعات تخفیف مشخص نیست", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                addDirectDiscount(model, (calback) => {
                  setState({
                    productID: undefined,
                    brandID: undefined,
                    groupID: undefined,
                    discountPercent: undefined,
                    discountCost: 0,
                  });
                  setName("");
                  setDiscountPercent2("");
                  props.callback();
                });
              }}
            >
              افزودن
            </Button>
            <Button
              sx={{ width: "70px" }}
              variant="contained"
              color="error"
              onClick={() => {
                setDeleteState({
                  show: true,
                  name: "تخفیف این برند",
                  brandID: state.brandID,
                });
              }}
            >
              حذف
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mb: 2,
          // bgcolor: "#e3e3e340",
          borderRadius: 1,
          p: 2,
          boxShadow: 2,
        }}
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gap={2}
      >
        <Box gridColumn="span 12">
          <SelectGroup
            Offer
            setName={setName}
            selectedGroupID={state.groupID && state.groupID}
            setter={setState}
            lvl1State={state}
          ></SelectGroup>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
          gridColumn="span 12"
        >
          <TextField
            sx={{
              width: isSmall ? "50%" : "18%",
              mr: 2,
              input: {
                textAlign: "center",
              },
            }}
            value={discountPercent3 ? discountPercent3 : ""}
            label="درصد تخفیف"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setDiscountPercent3(evt.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isSmall && "flex-end",
              // width: "100%",
              gap: 2,
            }}
          >
            <Button
              sx={{ width: "70px" }}
              variant="contained"
              onClick={() => {
                var model = {
                  groupID: state.groupID,
                  discountPercent: discountPercent3,
                };
                if (!model.groupID || !model.discountPercent) {
                  enqueueSnackbar("اطلاعات تخفیف مشخص نیست", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                addDirectDiscount(model, (calback) => {
                  setState({
                    productID: undefined,
                    brandID: undefined,
                    groupID: undefined,
                    discountPercent: undefined,
                    discountCost: 0,
                  });
                  setDiscountPercent3("");
                  props.callback();
                });
              }}
            >
              افزودن
            </Button>
            <Button
              sx={{ width: "70px" }}
              variant="contained"
              color="error"
              onClick={() => {
                setDeleteState({
                  show: true,
                  name: "تخفیف این گروه",
                  groupID: state.groupID,
                });
              }}
            >
              حذف
            </Button>
          </Box>
        </Box>
      </Box>
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={""}
        callback={() => {
          setProgress(true);
          if (deleteState.productID) {
            var model = {
              productID: deleteState.productID,
            };
          } else if (deleteState.groupID) {
            var model = {
              groupID: deleteState.groupID,
            };
          } else if (deleteState.brandID) {
            var model = {
              brandID: deleteState.brandID,
            };
          }
          deleteDirectDiscount(model, () => {
            setState({
              productID: undefined,
              brandID: undefined,
              groupID: undefined,
              discountPercent: undefined,
              discountCost: 0,
            });
            setName("");
            setDiscountPercent1("");
            setDiscountPercent2("");
            setDiscountPercent3("");
            props.callback();
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
